import DeleteIcon from "@mui/icons-material/Delete";
import {useSchedulersHandling} from "../../hooks/schedulers/useSchedulersHandling";
import {bindPopover, bindTrigger, usePopupState} from "material-ui-popup-state/hooks";
import {
    Button,
    capitalize,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Tooltip
} from "@mui/material";

interface ButtonDeleteSchedulerProps {
    schedulerId: string;
    disabled?: boolean;
    disabledReason?: string;
}

export default function ButtonDeleteScheduler({schedulerId, disabled, disabledReason}: ButtonDeleteSchedulerProps) {
    const {translation, deleteSchedulerMutation} = useSchedulersHandling();
    const popupState = usePopupState({
        variant: 'popover',
        popupId: `scheduler-${schedulerId}-delete`,
    });

    return (
        <>
            <Tooltip title={disabled ? (disabledReason ?? '') : ''}>
                <span>
                    <IconButton id={`button-delete-scheduler-${schedulerId}`}
                                aria-label={`button-delete-scheduler-${schedulerId}`}
                                disabled={disabled}
                                {...bindTrigger(popupState)}
                    >
                        <DeleteIcon/>
                    </IconButton>
                </span>
            </Tooltip>
            <Dialog id={`dialog-delete-scheduler-${schedulerId}`}
                    {...bindPopover(popupState)}
            >
                <DialogTitle id={`dialog-title-delete-scheduler-${schedulerId}`}>
                    {capitalize(translation('scheduler-delete-dialogue-title'))}
                </DialogTitle>
                <DialogContent id={`dialog-content-delete-scheduler-${schedulerId}`}>
                    <DialogContentText id={`dialog-content-text-delete-scheduler-${schedulerId}`}>
                        {capitalize(translation('scheduler-delete-dialogue-description'))}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button id={`dialog-action-cancel-delete-scheduler-${schedulerId}`}
                            color={'inherit'}
                            onClick={() => popupState.close()}
                    >
                        {capitalize(translation('abort'))}
                    </Button>
                    <Button id={`dialog-action-confirm-delete-scheduler-${schedulerId}`}
                            color={'error'}
                            variant={'contained'}
                            onClick={() => {
                                deleteSchedulerMutation.mutate(schedulerId);
                                popupState.close();
                            }}
                    >
                        {capitalize(translation('delete'))}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
